"use client";

import { useSession } from "@/lib/client/auth/client";
import { SignInButton } from "./SignInButton";
import { SignInDialog } from "./SignInDialog";
import { UserAccountNavItems } from "./UserAccountNavItems";

/**
 * UserAccountNav component - User account navigation
 */
export const UserAccountNav = () => {
  const { data: session } = useSession();

  return (
    <>
      {session?.user ? <UserAccountNavItems /> : <SignInButton />}
      <SignInDialog />
    </>
  );
};
